/* @flow */

import React from 'react'
import styled from 'styled-components'

export const FieldGroup = styled.div`
  margin-bottom: 10px;
`
